/* eslint-disable react-refresh/only-export-components */
// FIXME: resolve eslint-disable
import { useCurrentUser } from '@/features/users/users.hooks';
import { Recnum } from '@certhon/models';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { projectMutations, projectQueries } from './projects.queries';

interface MyQueryObserverOptions {
  suspense?: boolean;
  enabled?: boolean;
}

export function useProjects(options?: MyQueryObserverOptions) {
  return useQuery({ ...projectQueries.list(), ...options });
}
export function useArchivedProjects(options?: MyQueryObserverOptions) {
  return useQuery({ ...projectQueries.list({ archived: true }), ...options });
}

/**
 * Hook to get only the projects that the current user is following
 *  Note that this excludes archived projects
 */
export function useFollowedProjects(options?: MyQueryObserverOptions) {
  const currentUser = useCurrentUser();

  // Only fetch projects if user is authenticated
  const { data: allProjects, ...rest } = useProjects({
    ...options,
    enabled: !!currentUser,
  });

  const followedProjects = useMemo(() => {
    if (!allProjects || !currentUser) return [];
    return allProjects.filter((project) =>
      project.users.includes(currentUser.recnum),
    );
  }, [allProjects, currentUser]);

  return { data: followedProjects, ...rest };
}

const ProjectContext = createContext<number | null>(null);

// FIXME: Are we using this? do we need it?
export function ProjectDetailsDataProvider(
  props: PropsWithChildren<{
    projectId: number;
  }>,
) {
  useEffect(() => {}, [props.projectId]);
  return (
    <ProjectContext.Provider value={props.projectId}>
      {props.children}
    </ProjectContext.Provider>
  );
}

export function useProject(
  projectId?: Recnum,
  options?: MyQueryObserverOptions,
) {
  const ctxId = useContext(ProjectContext);
  const id = projectId || ctxId;
  if (!id) {
    throw new Error('No project id; either pass via param or context');
  }
  return useQuery({
    ...projectQueries.detail(id),
    ...options,
  });
}

/**
 * Hook to unfollow a project
 */
export function useUnfollowProject() {
  return useMutation(projectMutations.unfollow());
}
